import { ObjectTypeComposer } from "graphql-compose";
import { contains } from "ramda";

export default (type: ObjectTypeComposer) =>
  contains("ShowEmbedCode", type.getDirectiveNames());
